import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { SkeletonBox } from '../../../SkeletonBox/SkeletonBox.es.js';
import { InputContext } from '../../Input.Context/Input.Context.es.js';
import { InputInlineAffix } from '../../Input.Inline/Input.Inline.Affix/Input.Inline.Affix.es.js';
import '../../Input.Inline/Input.Inline.Button/Input.Inline.Button.es.js';
import { InputInlineIcon } from '../../Input.Inline/Input.Inline.Icon/Input.Inline.Icon.es.js';
import { InputInlineIconButton } from '../../Input.Inline/Input.Inline.IconButton/Input.Inline.IconButton.es.js';

const InputFieldCustom = ({ className, children, onContainerClick, ...rest })=>{
    const { loading, value, disabled, error, warning, display, labelProps, label } = useContext(InputContext);
    // Find inline subcomponents
    const inlineComponents = useMemo(()=>React__default.Children.toArray(children).filter((c)=>/*#__PURE__*/ React__default.isValidElement(c) && (c.type === InputInlineIcon || c.type === InputInlineIconButton || c.type === InputInlineAffix)), [
        children
    ]);
    // Find other subcomponents
    const otherComponents = useMemo(()=>React__default.Children.toArray(children).filter((c)=>!/*#__PURE__*/ React__default.isValidElement(c) || c.type !== InputInlineIcon && c.type !== InputInlineIconButton && c.type !== InputInlineAffix), [
        children
    ]);
    const fieldCustomCss = classNames('field-container', 'field-custom', {
        'has-value': Boolean(value),
        error,
        disabled,
        warning
    });
    return jsxs("div", {
        className: fieldCustomCss,
        onClick: onContainerClick,
        ...rest,
        children: [
            loading && jsx(SkeletonBox, {}),
            jsx("div", {
                className: "field-content",
                children: otherComponents
            }),
            label && display === 'inline' && jsx(InputInlineAffix, {
                intent: "label",
                labelProps: labelProps,
                variant: "prefix",
                children: label
            }),
            inlineComponents
        ]
    });
};
InputFieldCustom.displayName = 'Input.Field.Custom';

export { InputFieldCustom, InputFieldCustom as default };
//# sourceMappingURL=Input.Field.Custom.es.js.map
